import { render, staticRenderFns } from "./index-corporate.vue?vue&type=template&id=401c3412&"
import script from "./index-corporate.vue?vue&type=script&lang=js&"
export * from "./index-corporate.vue?vue&type=script&lang=js&"
import style0 from "./index-corporate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports